import React from 'react';

import SCIsTransaction from '../../components/Prospecting/SCIsTransaction/SCIsTransaction.module';

function SCIsTransactionView() {
  return (
    <SCIsTransaction />
  );
}

export default SCIsTransactionView;


